import axios from "axios";
import React, { useState, useEffect } from "react";
import { API_URL, FLOORPLAN_STYLES } from "../../Constants";

export default function Summary({ formSchema }) {
    const [showSummary, setShowSummary] = useState(false);
    const [allRoomType, setAllRoomType] = useState([]);

    const addOns = [];
    if (formSchema.add_ons && formSchema.add_ons.property_website === "true") {
        addOns.push("Single Property Website");
    }
    if (formSchema.add_ons && formSchema.add_ons.project_video === "true") {
        addOns.push("Single Property Video");
    }
    if (formSchema.isRapidDelivery === "YES") {
        if (formSchema.rapidTime && formSchema.rapidTime === "12hr") {
            addOns.push("Super Rapid Delivery");
        } else {
            addOns.push("Rapid Delivery");
        }
    }
    if (formSchema.add_ons && formSchema.add_ons.siteplan === "true") {
        addOns.push("Siteplan");
    }
    // if (formSchema.addOns) {
    //     Object.entries(formSchema.add_ons).map((ao => {
    //         if (ao[0][1] === "true") {
    //             addOns.push(ao[0][0].split("_")
    //                 .map((el) => el[0].toUpperCase() + el.slice(1))
    //                 .join(" "))
    //         }
    //     }))
    // }
    let showStyle = false;
    let showFurnAndRenoServ = false;

    if (formSchema.style !== "None") {
        showStyle = true;
    }

    if (
        formSchema.stype === "staging" ||
        formSchema.stype === "virtual_renovation"
    ) {
        showFurnAndRenoServ = true;
    }

    useEffect(() => {
        const getRoomTypes = async () => {
            if (formSchema.stype === "commercial_virtual_staging") {
                const commercialRoomTypes = [
                    { name: "Office", slug: "office", furniture: [] },
                    { name: "Lounge", slug: "lounge", furniture: [] },
                    { name: "Gym", slug: "gym", furniture: [] },
                    { name: "Reception Area", slug: "reception_area", furniture: [] },
                    { name: "Cafeteria", slug: "cafeteria", furniture: [] },
                    { name: "Other", slug: "other", furniture: [] },
                ];
                setAllRoomType(commercialRoomTypes);
            } else if (
                formSchema.stype === "day_to_dusk" ||
                formSchema.stype === "image_enhancement" ||
                formSchema.stype === "object_removal" ||
                formSchema.stype === "occupied_to_vacant"
            ) {
                setAllRoomType([]);
                // setIsPhotoEditing(true);
                if (
                    formSchema.stype === "object_removal" ||
                    formSchema.stype === "occupied_to_vacant"
                ) {
                    // setIsPeSer(false);
                }
            } else if (formSchema.stype === "floorplan") {
                setAllRoomType([]);
            } else {
                const resp = await axios({
                    method: "GET",
                    url: `${API_URL}/room_options/list`,
                });
                if (resp.data.status === "success") setAllRoomType(resp.data.data);
            }
        };
        getRoomTypes();
    }, []);

    function getRoomFurniture(k) {
        let arr = [];
        for (let i = 0; i < allRoomType.length; i++) {
            if (allRoomType[i].slug === k) {
                arr = allRoomType[i].furniture;
            }
        }
        return arr;
    }

    return (
        <div>
            <div className="ud-sum-sticky unstick">
                <div
                    className="ud-sum-titles-wrap"
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    <div
                        className="ud-sum-txt"
                        onClick={() => {
                            setShowSummary(!showSummary);
                            window.scrollBy(0, 200);
                        }}
                    >
                        ORDER&nbsp;SUMMARY
                        {showSummary ? (
                            <span className="ud-down"></span>
                        ) : (
                            <span className="ud-down"></span>
                        )}
                    </div>
                    <div
                        style={{ marginLeft: "10px", fontStyle: "italic" }}
                        onClick={() => {
                            setShowSummary(!showSummary);
                            window.scrollBy(0, 200);
                        }}
                    >
                        (Click to view order summary)
                    </div>
                </div>
                {showSummary ? (
                    <div className="ud-sum-wrap">
                        <div className="ud-sum-order-details w-row">
                            <div className="ud-sum-details-cont w-col w-col-6">
                                <div className="w-row">
                                    <div className="w-col w-col-4">
                                        <div className="ud-sum-lbl">Order ID</div>
                                        <div className="ud-sum-lbl-bl">{formSchema.orderID}</div>
                                    </div>
                                    <div className="w-col w-col-4">
                                        <div className="ud-sum-lbl">Project Type</div>
                                        <div className="ud-sum-lbl-bl">
                                            {formSchema.stype === "staging"
                                                ? "Virtual Staging"
                                                : formSchema.stype
                                                    .split("_")
                                                    .map((el) => el[0].toUpperCase() + el.slice(1))
                                                    .join(" ")}
                                        </div>
                                    </div>
                                    <div className="w-col w-col-4">
                                        <div className="ud-sum-lbl">Additional Services</div>
                                        <div className="ud-sum-lbl-bl">
                                            {addOns.length === 0
                                                ? "NA"
                                                : addOns.map((ao, idx) => {
                                                    return <div key={idx}>{ao}</div>;
                                                })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {formSchema.stype === "360_virtual_tour" ? (
                            <div className="ud-sum-order-details w-row">
                                <div className="ud-sum-details-cont w-col w-col-6">
                                    <div className="w-row">
                                        <div className="w-col w-col-4">
                                            <div className="ud-sum-lbl">Property Name</div>
                                            <div className="ud-sum-lbl-bl">
                                                {formSchema.propertyDetails.property_name}
                                            </div>
                                        </div>
                                        <div className="w-col w-col-4">
                                            <div className="ud-sum-lbl">Property Address</div>
                                            <div className="ud-sum-lbl-bl">
                                                {formSchema.propertyDetails.property_address}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            ""
                        )}

                        {showStyle ? (
                            <div className="ud-sum-stl-wrap">
                                <div className="ud-sum-lbl">Selected Furnishing Style</div>
                                <img
                                    src={
                                        formSchema.stype === "floorplan"
                                            ? FLOORPLAN_STYLES[formSchema.style].img
                                            : `https://cdn.styldod.com/feassets/webflow/image/Cover/${formSchema.style}.jpg`
                                    }
                                    loading="lazy"
                                    alt=""
                                    className="ud-sum-stl"
                                />
                                <div id="style" className="ud-sum-lbl-bl">
                                    {formSchema.stype === "floorplan"
                                        ? FLOORPLAN_STYLES[formSchema.style].name
                                        : formSchema.style}
                                </div>
                            </div>
                        ) : (
                            ""
                        )}

                        <div>
                            <div className="ud-sum-card">
                                <div className="ud-sum-lbl">Uploaded Images</div>
                                {allRoomType.length === 0 ? (
                                    <div className="ud-sum-list">
                                        {formSchema.image_details.map((id, idx) => {
                                            const optedService = Object.entries(id)
                                                .map(([k, v]) => {
                                                    return v === "true" ? k.split("_").join(" ") : null;
                                                })
                                                .filter(Boolean);

                                            return (
                                                <div
                                                    className="ud-sum-details-form rem-width w-row"
                                                    key={idx}
                                                >
                                                    {formSchema.stype === "floorplan" ? (
                                                        <>
                                                            <div className="ud-sum-img-detals w-col w-col-6 w-col-stack">
                                                                <div className="ud-sum-img-wrap w-inline-block">
                                                                    <img
                                                                        src={
                                                                            [
                                                                                "png",
                                                                                "jpg",
                                                                                "jpeg",
                                                                                "svg",
                                                                                "gif",
                                                                            ].indexOf(
                                                                                id.image.split(".").slice(-1)[0]
                                                                            ) > -1
                                                                                ? id.image
                                                                                : "https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/6022a1b9a3b70109de65496c_file-pl.png"
                                                                        }
                                                                        loading="lazy"
                                                                        className="ud-sum-img"
                                                                        alt={""}
                                                                    />
                                                                </div>
                                                                <div className="ud-sum-srno">
                                                                    {idx + 1}/{formSchema.image_details.length}
                                                                </div>
                                                            </div>
                                                            <div className="ud-sum-room-detals w-col w-col-6 w-col-stack">
                                                                <div className="ud-sum-details">
                                                                    <div className="ud-sl-lbl">
                                                                        Template orientation
                                                                    </div>
                                                                    <div className="ud-sl-val">
                                                                        {id.template_orientation}
                                                                    </div>
                                                                    <div className="ud-sl-lbl">Story/Level</div>
                                                                    <div className="ud-sl-val">
                                                                        {id.story_level}
                                                                    </div>

                                                                    <div className="ud-sl-lbl">
                                                                        What would you like in the floorplan?
                                                                    </div>
                                                                    <div className="w-row">
                                                                        {optedService.length === 0 ? (
                                                                            <div className="ud-sl-val">
                                                                                Not Selected
                                                                            </div>
                                                                        ) : (
                                                                            optedService.map((os, idx) => {
                                                                                return (
                                                                                    <div key={idx} className="ud-sl-val">
                                                                                        {os}
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <div className="ud-sum-img-detals w-col w-col-6 w-col-stack">
                                                                <div className="ud-sum-img-wrap w-inline-block">
                                                                    <img
                                                                        src={
                                                                            [
                                                                                "png",
                                                                                "jpg",
                                                                                "jpeg",
                                                                                "svg",
                                                                                "gif",
                                                                            ].indexOf(
                                                                                id.image.split(".").slice(-1)[0]
                                                                            ) > -1
                                                                                ? id.image
                                                                                : "https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/6022a1b9a3b70109de65496c_file-pl.png"
                                                                        }
                                                                        loading="lazy"
                                                                        alt={""}
                                                                        className="ud-sum-img"
                                                                    />
                                                                </div>
                                                                <div className="ud-sum-srno">
                                                                    {idx + 1}/{formSchema.image_details.length}
                                                                </div>
                                                            </div>
                                                            <div className="ud-sum-room-detals w-col w-col-6 w-col-stack">
                                                                <div className="ud-sum-details">
                                                                    {formSchema.stype === "occupied_to_vacant" ? (
                                                                        ""
                                                                    ) : formSchema.stype === "object_removal" ? (
                                                                        ""
                                                                    ) : (
                                                                        <>
                                                                            <div className="ud-sl-lbl">
                                                                                What would you like any of the below
                                                                                effects?
                                                                            </div>
                                                                            <div className="w-row">
                                                                                {optedService.length === 0 ? (
                                                                                    <div className="ud-sl-val">
                                                                                        Not Selected
                                                                                    </div>
                                                                                ) : (
                                                                                    optedService.map((os, idx) => {
                                                                                        return (
                                                                                            <div
                                                                                                key={idx}
                                                                                                className="ud-sl-val"
                                                                                            >
                                                                                                {os}
                                                                                            </div>
                                                                                        );
                                                                                    })
                                                                                )}
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                    <div className="ud-sl-lbl">
                                                                        Additional Information (Optional)
                                                                    </div>
                                                                    <div className="ud-sl-val">
                                                                        {id.info === "" ? `----` : id.info}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="ud-sum-list">
                                        {formSchema.image_details.map((id, idx) => {
                                            const optedService = Object.entries(id)
                                                .map(([k, v]) => {
                                                    return v === "true" ? k.split("_").join(" ") : null;
                                                })
                                                .filter(Boolean);

                                            let isSelected = false;
                                            let roomFurnitureName = [];
                                            if (formSchema.version === "v4") {
                                                if (Array.isArray(id.furniture)) {
                                                    getRoomFurniture(id.room).map((li) => {
                                                        if (id.furniture.indexOf(li.fid.toString()) > -1) {
                                                            roomFurnitureName.push(li.name);
                                                            isSelected = true;
                                                        }
                                                    });
                                                }
                                            }
                                            return (
                                                <div className="ud-sum-details-form w-row" key={idx}>
                                                    <div className="ud-sum-img-detals w-col w-col-4 w-col-stack">
                                                        <div className="ud-sum-img-wrap w-inline-block">
                                                            <img
                                                                src={
                                                                    ["png", "jpg", "jpeg", "svg", "gif"].indexOf(
                                                                        id.image.split(".").slice(-1)[0]
                                                                    ) > -1
                                                                        ? id.image
                                                                        : "https://assets.website-files.com/5dcf94bbedfe6a0469634ea8/6022a1b9a3b70109de65496c_file-pl.png"
                                                                }
                                                                loading="lazy"
                                                                className="ud-sum-img"
                                                                alt={""}
                                                            />
                                                        </div>
                                                        <div className="ud-sum-srno">
                                                            {idx + 1}/{formSchema.image_details.length}
                                                        </div>
                                                    </div>
                                                    <div className="ud-sum-room-detals w-col w-col-4 w-col-stack">
                                                        <div className="ud-sum-details">
                                                            <div className="ud-sl-lbl">Room/Area*</div>
                                                            <div className="ud-sl-val">
                                                                {id.room
                                                                    ? id.room === ""
                                                                        ? "----"
                                                                        : allRoomType.find(
                                                                            (rt) => rt.slug === id.room
                                                                        )
                                                                            ? allRoomType.find(
                                                                                (rt) => rt.slug === id.room
                                                                            ).name
                                                                            : id.room
                                                                                .split("_")
                                                                                .map(
                                                                                    (el) =>
                                                                                        el[0].toUpperCase() + el.slice(1)
                                                                                )
                                                                                .join(" ")
                                                                    : "NA"}
                                                            </div>
                                                            {showFurnAndRenoServ ? (
                                                                <>
                                                                    <div className="ud-sl-lbl">
                                                                        {formSchema.stype === "virtual_renovation"
                                                                            ? "Choose the renovation services you like to add."
                                                                            : "What would you like in the room?"}
                                                                    </div>
                                                                    <div className="w-row">
                                                                        {formSchema.stype ===
                                                                            "virtual_renovation" ? (
                                                                            id.services.map((ser, indx) => {
                                                                                return (
                                                                                    <div
                                                                                        className="w-col w-col-5 w-col-small-6 w-col-tiny-6"
                                                                                        key={indx}
                                                                                    >
                                                                                        <div className="ud-sl-val">
                                                                                            {ser
                                                                                                .split("_")
                                                                                                .map(
                                                                                                    (el) =>
                                                                                                        el[0].toUpperCase() +
                                                                                                        el.slice(1)
                                                                                                )
                                                                                                .join(" ")}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        ) : isSelected ? (
                                                                            roomFurnitureName.map((rfn, id) => {
                                                                                return (
                                                                                    <div
                                                                                        className="w-col w-col-5 w-col-small-6 w-col-tiny-6"
                                                                                        key={id}
                                                                                    >
                                                                                        <div className="ud-sl-val">
                                                                                            {rfn}
                                                                                        </div>
                                                                                    </div>
                                                                                );
                                                                            })
                                                                        ) : (
                                                                            <div className="ud-sl-val">
                                                                                Not Selected
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                ""
                                                            )}

                                                            <div className="ud-sl-lbl">
                                                                Not mentioned? Type them in here
                                                            </div>
                                                            <div className="ud-sl-val">
                                                                {id.info === "" ? `----` : id.info}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="ud-sum-as-detals w-col w-col-4 w-col-stack">
                                                        <div className="ud-sl-lbl">Additional services</div>
                                                        <div className="ud-sum-lbl-bl">
                                                            {optedService.length === 0
                                                                ? "NA"
                                                                : optedService.map((os, idx) => {
                                                                    return <div key={idx}>{os}</div>;
                                                                })}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div
                            className="ud-sum-footer"
                            onClick={() => {
                                setShowSummary(false);
                            }}
                        >
                            <div className="ud-hide-sum">
                                <strong></strong>
                            </div>
                            <div className="ud-sl-val">Hide order summary</div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        </div>
    );
}
